import Vue from "vue";
import store from "@/store";
import {
  Message
} from "element-ui";
import VueRouter from "vue-router";
import {
  getUserinfo
} from "@/api/person.js";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "index",
    redirect: "/",
    component: () => import("@/views/index.vue"),
    children: [{
        path: "/",
        name: "home",
        meta: {
          keepAlive: true, //此组件不需要被缓存
        },
        component: (resolve) => require(["@/views/home.vue"], resolve),
      },
      {
        path: "/personCenter",
        name: "personCenter",
        meta: {
          // 个人中心
          keepAlive: false,
        },
        component: (resolve) =>
          require(["@/views/personCenter/index.vue"], resolve),
      },
      {
        path: "/ranking",
        name: "ranking",
        meta: {
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/ranking.vue"], resolve),
      },
      {
        path: "/help",
        name: "help",
        meta: {
          keepAlive: true,
        },
        component: (resolve) => require(["@/views/help.vue"], resolve),
      },
      {
        path: "/blacklist",
        name: "blacklist",
        meta: {
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/blacklist.vue"], resolve),
      },
      {
        path: "/news",
        name: "news",
        meta: {
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/news.vue"], resolve),
      },
      {
        path: "/newsdetail/:id",
        name: "newsdetail-id",
        meta: {
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/newsdetail.vue"], resolve),
      },
      {
        path: "/finalize",
        name: "finalize",
        meta: {
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/finalize.vue"], resolve),
      },
      {
        path: "/vac",
        name: "vac",
        meta: {
          // 
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/vac.vue"], resolve),
      },
      {
        path: "/dishonesty",
        name: "dishonesty",
        meta: {
          // 
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/dishonesty.vue"], resolve),
      },
      {
        path: "/record",
        name: "record",
        meta: {
          // 
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/record.vue"], resolve),
      },
      {
        path: "/identify",
        name: "identify",
        meta: {
          // 
          keepAlive: false,
        },
        component: (resolve) => require(["@/views/identify.vue"], resolve),
      },
      {
        path: "404",
        name: "404",
        meta: {
          title: "404",
        },
        component: (resolve) => require(["@/views/404.vue"], resolve),
      },
    ],
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
  // 手机端路由
  {
    path: "/mobile",
    name: "mobile-home",
    meta: {
      keepAlive: true,
    },
    component: (resolve) => require(["@/views/mobile/home/home.vue"], resolve),
  },
  {
    path: "/mobile/ranking",
    name: "mobile-ranking",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/ranking/ranking.vue"], resolve),
  },
  {
    path: "/mobile/help",
    name: "mobile-help",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/help/help.vue"], resolve),
  },
  {
    path: "/mobile/blacklist",
    name: "mobile-blacklist",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/blacklist/blacklist.vue"], resolve),
  },
  {
    path: "/mobile/vac",
    name: "mobile-vac",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/vac/vac.vue"], resolve),
  },
  {
    path: "/mobile/news",
    name: "mobile-news",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/news/index.vue"], resolve),
  },
  {
    path: "/mobile/newsdetail/:id",
    name: "mobile-newsdetail-id",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/news/detail.vue"], resolve),
  },
  {
    path: "/mobile/dishonesty",
    name: "mobile-dishonesty",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/dishonesty/dishonesty.vue"], resolve),
  },
  {
    path: "/mobile/share",
    name: "mobile-share",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/share/share.vue"], resolve),
  },
  {
    path: "/mobile/identify",
    name: "mobile-identify",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/identify/identify.vue"], resolve),
  },
  {
    path: "/mobile/personal",
    name: "mobile-personal",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/index.vue"], resolve),
  },
  {
    path: "/mobile/personal/setting",
    name: "mobile-personal-setting",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/setting.vue"], resolve),
  },
  {
    path: "/mobile/personal/recharge",
    name: "mobile-personal-recharge",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/recharge.vue"], resolve),
  },
  {
    path: "/mobile/personal/associate",
    name: "mobile-personal-associate",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/associate.vue"], resolve),
  },
  {
    path: "/mobile/personal/notice",
    name: "mobile-personal-notice",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/notice.vue"], resolve),
  },
  {
    path: "/mobile/personal/gather",
    name: "mobile-personal-gather",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/gather.vue"], resolve),
  },
  {
    path: "/mobile/personal/draw",
    name: "mobile-personal-draw",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/draw.vue"], resolve),
  },
  {
    path: "/mobile/personal/valuate",
    name: "mobile-personal-valuate",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/valuate.vue"], resolve),
  },
  {
    path: "/mobile/personal/gatherdeducte",
    name: "mobile-personal-gatherdeducte",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/gatherdeducte.vue"], resolve),
  },
  {
    path: "/mobile/personal/dishonestydeducte",
    name: "mobile-personal-dishonestydeducte",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/dishonestydeducte.vue"], resolve),
  },
  {
    path: "/mobile/personal/payment",
    name: "mobile-personal-payment",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/payment.vue"], resolve),
  },
  {
    path: "/mobile/personal/share",
    name: "mobile-personal-share",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/share.vue"], resolve),
  },
  {
    path: "/mobile/personal/blacklist",
    name: "mobile-personal-blacklist",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/blacklist.vue"], resolve),
  },
  {
    path: "/mobile/personal/blacklistfund",
    name: "mobile-personal-blacklistfund",
    meta: {
      keepAlive: false,
    },
    component: (resolve) => require(["@/views/mobile/personal/blacklistfund.vue"], resolve),
  }
];
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
});

router.afterEach((to, from) => {
  //from中包含跳转前的路由信息，to包含跳转到的目的路由信息
  if (store.state.login != 1) {
    // 在登录状态下，每次切换页面则调一次用户详情，刷新权限
    getUserinfo().then((res) => {
      // console.log(res);
      store.commit("setUserInfo", res.userinfo);
      store.commit("setToken", res.userinfo.token);
      if (res.userinfo && !res.userinfo.rules.includes("1")) {
        // 如果没主播模式权限，要把主播模式改为未开启，用于在线修改权限的情况
        store.commit("setLiveTypes", 0);
      }
    });
    // 登录状态下每次切换页面重新获取通知
    store.dispatch('initNoticeList')
  } else {
    // 退出状态下清空通知
    store.commit('setNoticeList', [])
  }
});

// // 防止连续点击多次路由报错
// let routerPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(err => err)
// }
export default router;